import {VirtualTable} from "@devexpress/dx-react-grid-material-ui";
import {withStyles} from "@material-ui/core/styles";
import React from "react";
import {tableStyle} from "../../../utils/tables";

const VirtualHeadComponentBase = ({ classes, ...restProps }) => (
	<VirtualTable.TableHead
		{...restProps}
		className={"VirtualTableHeaders"}
	/>
);
export default withStyles(tableStyle, { name: 'VirtualHeadComponent' })(VirtualHeadComponentBase);



// WEBPACK FOOTER //
// ./src/common/components/table/components/virtual-table-components.js